
import { defineComponent, inject, ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { AxiosError } from "axios";
import { useToast } from "vue-toastification";

// components
import EmailTemplateList from "@/components/molecules/EmailTemplateList.molecules.vue";

// services
import emailService from "@/services/email.service";

// interfaces
import { IEmail } from "@/interfaces/email";

export default defineComponent({
  components: {
    EmailTemplateList,
  },
  setup() {
    const setPageTitle = inject("setPageTitle") as CallableFunction;
    const setIsLoading = inject("setIsLoading") as CallableFunction;

    const toast = useToast();
    const route = useRoute();
    const isShown = ref<boolean>(false);

    const isLoading = ref<boolean>(false);
    const templates = ref<IEmail[]>([]);
    const selectedTemplate = ref<string | undefined>(undefined);

    const emailTemplateIdParam = ref(String(route.params.id ?? ""));

    const setSelectedTemplate = (val: string) => {
      selectedTemplate.value = val;
    };

    const closeModal = () => {
      isShown.value = false;
      emailTemplateIdParam.value = "";
    };

    const setDefaultTemplate = async (id: string) => {
      try {
        setIsLoading(true);

        await emailService.setDefaultEmailTemplate(id);

        toast.success("Template email berhasil diset default");
        getEmailTemplates();
        closeModal();
      } catch (e) {
        let errMsg = (e as AxiosError).response?.data?.error || "Ada kesalahan";
        toast.error(errMsg);
      } finally {
        setIsLoading(false);
      }
    };

    const deleteTemplate = async (id: string) => {
      try {
        setIsLoading(true);

        await emailService.deleteEmailTemplate(id);

        toast.success("Template email berhasil dihapus");
        getEmailTemplates();
      } catch (e) {
        let errMsg = (e as AxiosError).response?.data?.error || "Ada kesalahan";
        toast.error(errMsg);
      } finally {
        setIsLoading(false);
      }
    };

    const getEmailTemplates = async () => {
      isLoading.value = true;
      const { data } = await emailService.getEmailTemplates();
      templates.value = [...data];

      const defaultTemplate = data.find((d: IEmail) => d.is_default === 1);
      if (defaultTemplate) setSelectedTemplate(defaultTemplate.id);
      isLoading.value = false;
    };

    onMounted(async () => {
      setPageTitle("");

      await getEmailTemplates();

      if (emailTemplateIdParam.value) {
        isShown.value = true;
      }
    });

    return {
      // data
      isShown,
      isLoading,
      templates,
      selectedTemplate,
      emailTemplateIdParam,

      // methods
      setSelectedTemplate,
      getEmailTemplates,
      setDefaultTemplate,
      deleteTemplate,
      closeModal,
    };
  },
});
